import React, { useEffect, useState } from 'react'
import axios from 'axios';

export default function Compfoto({ sendhargafoto, indexfoto, jammulai, tanggal, jmljam }) {
  const [foto, setFoto] = useState([]);
  const [show, setShow] = useState(false)
  const urlapi = process.env.REACT_APP_BASE_URL
  const [valfoto, setValfoto] = useState('')
  const [items, setItems] = useState([]);
  const [bookfoto, setBookfoto] = useState([]);
  const [ganjilgenap, setGanjilgenap] = useState('');
  const i = indexfoto + 1;
  const p = i % 2;

  const getfoto = async () => {
    try {
      const response = await axios.get(urlapi + "Fotografer");
      setFoto(response.data);
    } catch (error) { }
  };

  const formatrupiah = (numb) => {
    const format = numb.toString().split("").reverse().join("");
    const convert = format.match(/\d{1,3}/g);
    const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
    return rupiah;
  };

  const handlefoto = (e, idfoto, hargafoto) => {
    const isChecked = e.target.checked;
    const storedItems = JSON.parse(localStorage.getItem("selectedItems"));
    const updatedItems = [...storedItems];
    const newItemData = {
      idfoto: idfoto,
      hargafoto: hargafoto
    };
    if (isChecked) {
      setValfoto(idfoto);
      sendhargafoto(hargafoto, true);
      updatedItems[indexfoto] = {
        ...updatedItems[indexfoto], // Salin data lama
        ...newItemData, // Update data baru
      };
    } else {
      setValfoto('')
      sendhargafoto(hargafoto, false);
      const updatedItems = [...storedItems];
      if (updatedItems[indexfoto]) {
        delete updatedItems[indexfoto].hargafoto;
        delete updatedItems[indexfoto].idfoto;
      }

    }
    localStorage.setItem("selectedItems", JSON.stringify(updatedItems));
    setItems(updatedItems);
  }

  const cekfoto = async () => {
    try {
      const response = await axios.get(urlapi + "Cekbookfoto?tgl=" + tanggal + "&&jammulai=" + jammulai)
      console.log(response.data);
      setBookfoto(response.data);

    } catch (error) {
      console.log(error.message);

    }
  }
  useEffect(() => {
    getfoto();
    cekfoto();
    const storedItems = localStorage.getItem("selectedItems");
    if (storedItems) {
      setItems(JSON.parse(storedItems)); // Set data ke state
    }
    if (jmljam % 2 === 0) {
      setGanjilgenap('genap');
    } else {
      setGanjilgenap('ganjil')
    }
  }, [])
  return (
    <div className='card mt-1'>
      <div className='card-body'>
        <div className='d-flex justify-content-between fw-bold mb-2' onClick={() => setShow(!show)}>
          <small><i className='fas fa-camera'></i> Fotograper</small>
          <small>{valfoto != '' ? <i className='fas fa-circle-check text-success'></i> : ''} {' '} <i className={show == false ? 'fas fa-angle-right' : 'fas fa-angle-down'}></i></small>
        </div>


        <div className={show == false ? 'd-none' : ''}>
          {
            bookfoto.status == 'book' ?
              <>
                <div className='text-center alert alert-danger border-0' style={{ fontSize: '12px' }}>
                  <small>Mohon maaf layanan fotograper untuk di tanggal
                    dan jam yang anda pilih sudah digunakan oleh pengguna lain. Ubah tanggal main atau jam main untuk dapat menggunakan layanan fotograper</small>
                </div>
              </>
              :
              <>
                {foto.map((data, index) => {
                  return (
                    <div
                      key={index}
                      className={p == 0 ? 'opacity-50 pe-none' : ''} style={{ display: jmljam == i && data.jml_jam == 2 ? 'none' : '' }}>
                      {tanggal >= data.tgl_tutup_mulai && tanggal <= data.tgl_tutup_selesai ?
                        <>
                          {jammulai >= data.jam_tutup_mulai && jammulai <= data.jam_tutup_selesai ?
                            <div className='text-danger text-center' style={{ fontSize: '12px' }}>
                              Layanan fotograper untuk tanggal dan jam ini tidak tersedia
                            </div>
                            :
                            <div>
                              <div className='d-flex justify-content-between' key={index}>
                                <div>
                                  <small style={{ color: "#2b2e5a" }} className='fw-bold'>{data.nama}</small>
                                  <div>
                                    {data.harga2 == '' ? '' : <small><s>{formatrupiah(data.harga2)}</s></small>}
                                  </div>
                                  <div><span className='badge rounded-pill bg-success'>{formatrupiah(data.harga)}</span></div>
                                </div>
                                <div>
                                  <div class="form-check">
                                    <img
                                      src={
                                        "https://ratumerak.id/adminmmsc/assets/berkas/" +
                                        data.foto
                                      }
                                      className="img-fluid"
                                      alt="Responsive image"
                                      style={{ height: "40px" }}
                                    ></img>
                                    <input
                                      class="form-check-input  border border-danger"
                                      type="checkbox"
                                      name="foto"
                                      onChange={(e) => handlefoto(e, data.id, data.harga)}
                                      id="foto"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>}

                        </>
                        :
                        <div>
                          <div className='d-flex justify-content-between' key={index}>
                            <div>
                              <small style={{ color: "#2b2e5a" }} className='fw-bold'>{data.nama}</small>
                              <div>
                                {data.harga2 == '' ? '' : <small><s>{formatrupiah(data.harga2)}</s></small>}
                              </div>
                              <div><span className='badge rounded-pill bg-success'>{formatrupiah(data.harga)}</span></div>
                            </div>
                            <div>
                              <div class="form-check">
                                <img
                                  src={
                                    "https://ratumerak.id/adminmmsc/assets/berkas/" +
                                    data.foto
                                  }
                                  className="img-fluid"
                                  alt="Responsive image"
                                  style={{ height: "40px" }}
                                ></img>
                                <input
                                  class="form-check-input  border border-danger"
                                  type="checkbox"
                                  name="foto"
                                  onChange={(e) => handlefoto(e, data.id, data.harga)}
                                  id="foto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <hr />
                    </div>
                  )
                })}



                {foto == '' ? <><div className='text-danger text-center' style={{ fontSize: '12px' }}>Layanan Fotograper untuk saat ini tidak dibuka{ }</div></> : <></>}
              </>
          }

        </div>
      </div>
    </div>
  )
}

